var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',_vm._b({attrs:{"options":_vm.branchOptions,"show-labels":false,"allow-empty":false,"placeholder":""},on:{"input":_vm.updateValue}},'multiselect',{ value: _vm.value },false))}
var staticRenderFns = []

export { render, staticRenderFns }